/**
 Interface für selektierbare Einträge der Filter
 z.B. für Checkboxen, Radiobuttons etc
 */
export interface FilterSelectItem {
  key: string;
  ariaLabel: string;
  treffer: number;
  label: string;
  selected: boolean;
  active: boolean;
  /**
   * Modal: wenn vorhanden, wird ein Info-I erzeugt, über das ein Popup geöffnet werden kann
   */
  modal?: {
    id: string;
    ariaLabel: string;
  };
}

// There is an issue with the TrackByFunction provided by Angular
// This is a workaround to fix the isse. See: https://github.com/angular/angular/issues/40125
type TrackByFunction<T> = <U extends T>(index: number, item: U) => any;

export const trackByItemKey: TrackByFunction<{
  key: string;
}> = (_, { key }) => key;
